export const STORE_TRANSLATIONS = 'STORE_TRANSLATIONS';
export const storeTranslations = (translations) => ({
  type: STORE_TRANSLATIONS,
  translations,
});

export const STORE_LOCALE = 'STORE_LOCALE';
export const storeLocale = (locale) => ({
  type: STORE_LOCALE, locale,
});

export const STORE_AVAILABLE_LOCALES = 'STORE_AVAILABLE_LOCALES';
export const storeAvailableLocales = (locales) => ({
  type: STORE_AVAILABLE_LOCALES,
  locales,
});
